import { MoreMenu } from "datastake-daf/dist/components";
import { renderAccessibility } from "../../../helper";
import { renderData } from "../../../../DataStore/DataStoreView/config";

export const selectFiltersConfig = {};

export const filtersConfig = {
  datastakeId: '',
  name: '',
};

export const checkboxConfig = {
  datastakeId: 'ID',
  name: 'Name',
};

export const columnsConfig = ({
  t = (s) => s,
  user = {},
  onGetData = () => { },
  onViewDetails = () => { },
}) => [
    {
      title: t('ID'),
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }

        return item.datastakeId || item.id;
      },
    },
    {
      title: t('Data Point Label'),
      dataIndex: 'label',
      key: 'label',
      ellipsis: true,
    },
    {
      title: t('Data Point'),
      dataIndex: 'data',
      key: 'data',
      ellipsis: true,
      render: (v, item) => {
        if (item.empty) {
          return <div className="daf-default-cell" />;
        }
        return renderData(v, { [item.dataId]: item.input }, item.dataId);
      }
    },
    {
      title: t('Accessibility'),
      dataIndex: 'accessibility',
      key: 'accessibility',
      ellipsis: true,
      render: (val, all) => {
        if (all.empty) {
          return <div className="daf-default-cell" />;
        }

        const isOwn = !!all?.channels?.find((it) => it.inbound === user.company?.id && it.outbound === user.company?.id);
        if (isOwn) {
          return renderAccessibility({ val: 'own', t })
        }
        
        const isAcquired = !!all?.channels?.find((it) => it.inbound === user.company?.id);
        if (isAcquired) {
          return renderAccessibility({ val: 'acquired', t })
        }

        return renderAccessibility({ val, t })
      },
    },
    {
      title: t('Versions'),
      dataIndex: 'version',
      key: 'version',
      ellipsis: true,
    },
    {
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      width: 60,
      render: (_, val) => {
        if (val.empty) {
          return <div className="daf-default-cell" />;
        }

        const items = [];

        const getDataDisabled = !!(val?.channels || [])
          .filter((it) => it.inbound === user.company?.id || it.outbound === user.company?.id)
          .find((it) => it.discoverability === 'private' || it.inbound === user.company?.id);

        switch (val.accessibility) {
          case 'acceptance':
            items.push({ key: 'requestData', label: t('Request Data'), onClick: () => { }, disabled: true });
            break;
          case 'unrestricted':
            items.push({ key: 'getData', label: t('Get Data'), onClick: () => onGetData(val), disabled: getDataDisabled })
            break;
          default:
        }

        items.push({ key: 'viewDetails', label: t('Disclosure Settings'), onClick: () => onViewDetails(val) });

        return (
          <MoreMenu items={items} />
        );
      },
      ellipsis: true,
    },
  ]
